import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  padding-top: 70px;
  padding-right: 20px;
  overflow: hidden;
  z-index: 2;
`;
